import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginButton from "./pages/LoginMicrosoft";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import LoginSuccess from "./pages/LoginSuccess";
import AdminPage from "./pages/AdminPage";
import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { forceLogout } from "./config/authConfig";

function App() {
  const { instance } = useMsal();

  useEffect(() => {
    const logoutAfterTime = () => {
      forceLogout(instance);
    };
    const interval = setInterval(logoutAfterTime, 2700000);
    return () => clearInterval(interval);
  }, [instance]);

  return (
    <Router>
      <AuthenticatedTemplate>
        <div className="app">
          <Routes>
            <Route path="/" element={<LoginSuccess />}></Route>
            <Route path="/admin" element={<AdminPage />}></Route>
          </Routes>
        </div>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <LoginButton />
      </UnauthenticatedTemplate>
    </Router>
  );
}

export default App;
